// Core
import React, { useState, useEffect } from "react";

// Components - Contrib Libraries
import { Button, Collapse } from "react-bootstrap";

// Components - Custom
import Questions from "../components/questions";

function Headers(props) {
	const { headers, lastAlphaHeaderLoaded } = props;

	const [toggleCollapse, setToggleCollapse] = useState({});
	const [toggleAllCollapse, setToggleAllCollapse] = useState();
	const abc = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

	useEffect(() => {
		var accordions = {};
		for (var item of headers) {
			accordions[item.ID] = window.location.hash.includes("anchor") ? true : false;
		}
		setToggleCollapse(accordions);
	}, [headers]);

	function toggleAll() {
		var accordions = {};
		for (var item of headers) {
			accordions[item.ID] = !toggleAllCollapse;
			setToggleAllCollapse(!toggleAllCollapse);
		}
		setToggleCollapse(accordions);
	}

	if (!toggleCollapse) return null;

	return (
		<>
			{headers.map((item, i) => {
				const { ID, questions, Header_Name } = item;
				if (item.Header_Name === "" || !item.Header_Name) {
					return <Questions key={ID} questions={questions} lastHeaderLoaded={lastAlphaHeaderLoaded && true} />;
				} else {
					return (
						<div key={item.ID}>
							{i === 0 && (
								<Button variant="link" onClick={toggleAll} className="toggler text-primary ms-3 me-0">
									Expand/Collapse All Headers
								</Button>
							)}
							<div>
								<a
									href={window.location.hash.split("?")[0] + "?anchor=" + ID}
									className={"panelTrigger " + toggleCollapse[item.ID]}
									onClick={(e) => {
										e.preventDefault();

										// Update URL with anchor every time the Question is cliked
										window.history.replaceState({}, "", window.location.hash.split("?anchor=")[0] + "?anchor=" + ID);
										setToggleCollapse({
											...toggleCollapse,
											[item.ID]: !toggleCollapse[item.ID],
										});
									}}
								>
									<span className="mx-3">{abc[i] + "."}</span>
									{Header_Name}
								</a>
								<Collapse in={toggleCollapse[item.ID]}>
									<div className="ps-4 position-relative">
										<Questions questions={questions} lastHeaderLoaded={lastAlphaHeaderLoaded && i + 1 === headers.length} />
									</div>
								</Collapse>
							</div>
						</div>
					);
				}
			})}
		</>
	);
}

export default Headers;
